'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _utils = require('../utils');

var utils = _interopRequireWildcard(_utils);

var _experiments = require('../experiments');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FullStoryLoader = function () {
  function FullStoryLoader(emitter, options) {
    (0, _classCallCheck3.default)(this, FullStoryLoader);

    this._emitter = emitter;
    this._options = options;
    this._isChild = false;
    this._labels = [options.label];
  }

  (0, _createClass3.default)(FullStoryLoader, [{
    key: '_isContainerRecording',
    value: function _isContainerRecording() {
      var _this = this;

      return new _promise2.default(function (resolve) {
        var removeListener = null;

        var timeout = setTimeout(function () {
          removeListener();
          resolve(false);
        }, 100);

        removeListener = _this._emitter.listenOnce('WIX_FULLSORY_PONG', function () {
          clearTimeout(timeout);
          resolve(true);
        });

        _this._emitter.emit('WIX_FULLSORY_PING', _this._options.label, window.parent);
      });
    }
  }, {
    key: '_setupListeners',
    value: function _setupListeners() {
      var _this2 = this;

      this._emitter.listen('WIX_FULLSORY_PING', function (e, payload) {
        if (_this2._isChild) {
          _this2._emitter.emit('WIX_FULLSORY_PING', payload, window.parent);
        } else {
          _this2._labels.push(payload);
          FS.setUserVars({ labels_str: _this2._labels.join(',') });
        }

        _this2._emitter.emit('WIX_FULLSORY_PONG', '', e.source, e.origin);
      });
    }
  }, {
    key: '_prepareFullStoryPlaceholder',
    value: function _prepareFullStoryPlaceholder() {
      var g = window.FS = function (a, b) {
        return g.q ? g.q.push([a, b]) : g._api(a, b);
      };
      FS.setUserVars = function (v) {
        return v && g('user', v);
      };
      FS.identify = function (i, v) {
        g('user', { uid: i });
        g.setUserVars(v);
      };
      FS.event = function (n, p, s) {
        return g('event', { n: n, p: p, s: s });
      };
      FS.q = [];
    }
  }, {
    key: '_configureFullStoryGlobals',
    value: function _configureFullStoryGlobals() {
      window._fs_debug = false;
      window._fs_host = this._options.host || 'www.fullstory.com';
      window._fs_org = this._options.org || '1zuo';
      if (this._isChild) {
        window._fs_run_in_iframe = true;
      } else if (window !== window.top) {
        window._fs_is_outer_script = true;
      }
    }
  }, {
    key: '_loadFullStoryScript',
    value: function _loadFullStoryScript() {
      utils.lazyLoadScript('//' + window._fs_host + '/s/fs.js', 'fs-jstag');
    }
  }, {
    key: '_load',
    value: function _load() {
      this._prepareFullStoryPlaceholder();
      this._configureFullStoryGlobals();
      this._loadFullStoryScript();
    }
  }, {
    key: '_reportWhenSessionReady',
    value: function _reportWhenSessionReady() {
      var _this3 = this;

      if (this._options.onReady) {
        window._fs_ready = function () {
          _this3._options.onReady(FS.getCurrentSessionURL());
        };
      }
    }
  }, {
    key: '_identify',
    value: function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
        var _utils$getUserDetails, userId, userDetails, additionalData;

        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _utils$getUserDetails = utils.getUserDetails(this._options), userId = _utils$getUserDetails.userId, userDetails = _utils$getUserDetails.userDetails;
                additionalData = this._options.identifyData || {};


                window.FS.identify(userId, (0, _extends3.default)({}, userDetails, additionalData));

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function _identify() {
        return _ref.apply(this, arguments);
      }

      return _identify;
    }()
  }, {
    key: '_checkSample',
    value: function _checkSample() {
      var options = this._options;
      var originalSample = options.sample;

      if (originalSample === undefined && !utils.getCookieValue('_wixCIDX') && process.env.NODE_ENV === 'production') {
        options.sample = 0.1;
      }
      var mustRecord = window.location.toString().indexOf('alwaysfs') !== -1 || options.sample !== undefined && Math.random() < options.sample;

      if (mustRecord) {
        return _promise2.default.resolve();
      }

      var conditions = [originalSample === undefined && options.spec && (0, _experiments.conductExperiment)(options.spec), !this._isChild && (0, _experiments.conductExperiment)('specs.FullStoryGlobal')].filter(function (x) {
        return x;
      });

      return utils.somePromise(conditions.map(utils.boolToPromise));
    }
  }, {
    key: 'setup',
    value: function () {
      var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
        var _this4 = this;

        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this._isChild = window !== window.top;

                _context2.t0 = this._isChild;

                if (!_context2.t0) {
                  _context2.next = 6;
                  break;
                }

                _context2.next = 5;
                return this._isContainerRecording(this._options);

              case 5:
                _context2.t0 = _context2.sent;

              case 6:
                if (!_context2.t0) {
                  _context2.next = 11;
                  break;
                }

                this._setupListeners();
                this._load();
                _context2.next = 12;
                break;

              case 11:
                this._checkSample().then(function () {
                  _this4._reportWhenSessionReady();

                  _this4._isChild = false;

                  _this4._setupListeners();
                  _this4._load();
                  _this4._identify();
                }).catch(function () {
                  return undefined;
                });

              case 12:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function setup() {
        return _ref2.apply(this, arguments);
      }

      return setup;
    }()
  }]);
  return FullStoryLoader;
}();

exports.default = FullStoryLoader;